<div class="feed">
  <!-- Spinner -->
  <div *ngIf="isLoading" class="text-center my-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <!-- Post List -->
  <ng-container *ngIf="!isLoading && communityPosts && communityPosts.length > 0; else noPosts">
    <app-post-item
    *ngFor="let post of communityPosts; trackBy: trackByPostId"
    [post]="post"
    [isMobile]="isMobile"
    [activeReplyPostId]="activeReplyPostId"
    [submittingReplyPostId]="submittingReplyPostId" 
    (toggleReply)="toggleReply($event)" 
    (submitReply)="submitReply($event)"
    [communityID]="communityID"
    [currentUserId]="userId"
    [availabiltyDurations] = "availabiltyDurations"
    (deletePost)="onDeletePost($event)"
    [isRecruiter] = "isRecruiter"
    >
    
  </app-post-item>
  
  </ng-container>



  <!-- No posts fallback -->
  <ng-template #noPosts>
    <div class="text-center text-muted mt-4">
      <i class="bi bi-chat-left-dots fs-1"></i>
      <p>No posts yet. Be the first to start a discussion!</p>
    </div>
  </ng-template>
</div>


